/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');

var TimeTrkInvalidTimesheetView = require('../../common/views/TimeTrkInvalidTimesheetView');
var GetTimesheet = require('../../common/services/GetTimesheet');
var GetAllCategories = require('../../common/services/GetAllCategories');
var GetAllWorksites = require('../../common/services/GetAllWorksites');
var GetAllEntityLookups = require('../../../depository/common/services/GetAllEntityLookups');
var TimeTrkDepExaminerEntryView = require('../views/TimeTrkDepExaminerEntryView');

module.exports = {
  channel: 'tt',

  event: 'build:time-trk-dep-timesheet-view',

  builder: function(periodId, departmentId) {
    return new PlaceholderView({
      viewPromise: buildTimeTrkDepTimesheetView(periodId, departmentId)
    });
  }
};

function buildTimeTrkDepTimesheetView(periodId, departmentId) {
  var deferred = $.Deferred();
  $.when(
    GetTimesheet({ periodId: periodId, departmentId: departmentId }),
    GetAllEntityLookups(),
    GetAllCategories(departmentId),
    GetAllWorksites()
  )
    .done(function(timesheet, entityLookups, categories, worksites) {
      if (timesheet.timesheetId) {
        deferred.resolve(
          new TimeTrkDepExaminerEntryView({
            model: new Backbone.Model({
              timesheetId: timesheet.timesheetId,
              payPeriod: timesheet.payPeriod,
              categories: categories,
              timesheet: timesheet,
              entityCategories: entityLookups.entityCategories,
              entityTypes: entityLookups.entityTypes,
              worksites: worksites
            })
          })
        );
      } else {
        deferred.resolve(new TimeTrkInvalidTimesheetView());
      }
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
